// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__1b3Gt","btn-primary":"Button_btn-primary__3i3Pl","btn-secondary":"Button_btn-secondary__ukjts"};